import { BasicsClass } from '@/common/BasicsClass';
import { Util } from '@/common/util';

export class IdolSupplementCreateGoodsOrderAPI extends BasicsClass {
    public apiUrls: any = new Map([
        ['getSaleMachnieGoodsList', {
            url: '/admin/ktv/sellerMachine/goodsList',
            name: 'seller-machine-goods-list',
            label: '大明星售卖柜商品列表'
        }],

        ['supplementSaleMachineGOrder', {
          url: '/admin/ktv/goods/exception/supplement',
          name: 'supplement-create-goods-order',
          label: '补充处理大明星售卖柜商品异常订单'
        }],
    ])

    // 大明星售卖柜商品列表
    public getSaleMachnieGoodsList(params: any, successCb: Function, failCb: Function, showLoading: boolean = false) {
        const apiUrls = this.apiUrls

        const url = apiUrls.get('getSaleMachnieGoodsList').url

        this.BasicPost(url, {
            ...params
        }, false, false, false, successCb, failCb, showLoading)
    }

     // 补充处理大明星售卖柜商品异常订单
    public supplementSaleMachineGOrder(params: any, successCb: Function, failCb: Function, showLoading: boolean = false) {
      const apiUrls = this.apiUrls

      const url = apiUrls.get('supplementSaleMachineGOrder').url

      this.BasicPost(url, {
          ...params
      }, false, false, false, successCb, failCb, showLoading)

    }
    
}